import { memo } from 'react';
import { List, ListProps, Datagrid, CreateButton, ShowButton, TextField, DateField, usePermissions } from 'react-admin';
import { verifyAccess } from '../../utils/resourcePermissons';
import { TopToolBar } from '../shared-components';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import InboxIcon from '@mui/icons-material/Inbox';

const NoteCreateButton = memo((props: any) => {
  const { permissions } = usePermissions()
  const path = `/notes/create/${props.id}`
  return verifyAccess(permissions, 'driver', 'update') ? (<CreateButton to={{ pathname: path, state: { id: props.id, goBackUrl: props.location?.pathname } }} label="Create note" />) : null
});

const ListActions = (props: any) => {
  return (
    <TopToolBar right={<NoteCreateButton {...props} />} />
  )
};

const Empty = memo((props: any) => {
  return (
    <Box textAlign="center" m={1} sx={{color: 'rgba(0, 0, 0, 0.5)'}}>
      <InboxIcon sx={{ fontSize: 180 }}/>
      <Typography variant="h4" paragraph>
        No notes found
      </Typography>
      <NoteCreateButton {...props} />
    </Box>
  );
});

const notesRowStyle = (record: any) => ({
  backgroundColor: record.text.startsWith('{"field":') ? 'white' : '#f2f2f2'
});

export const NotesList: React.FC<ListProps> = (props: any) => {
  // Still determining whoh should actually be allowed to edit.  Leaving disabled for now
  // const CutomEditButton = (data:any) => {
  //   const editPath = `/notes/${data.record.id}/edit`;
  //   return <EditButton to={{pathname: editPath, state: {goBackUrl: props.location?.pathname}}} record={data.record} />
  // }
    
  const CustomShowButton = (data:any) => {
    const showPath = `/notes/${data.record.id}/show`;
    return <ShowButton to={{pathname: showPath, state: {goBackUrl: props.location?.pathname}}} record={data.record} />
  }
      
  return (
    <List {...props}
      title="All notes"
      pagination={false}
      exporter={false}
      actions={<ListActions {...props} />}
      bulkActionButtons={false}
      empty={<Empty {...props} />}
    >
      <Datagrid rowStyle={notesRowStyle}>
        <TextField source="author" label="Author"/>
        <TextField source="author_type" label="Author Type"/>
        <TextField source="source" label="Source"/>
        <TextField source="summary" label="Summary"/>
        <DateField showTime source="created_at" label="Created at"/>
        {/* {verifyAccess(props.permissions, 'customer', 'update')  ? <CutomEditButton /> : null} */}
        <CustomShowButton/>
      </Datagrid>
    </List>
  )};

